import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import IMedia, { IModifiedMedia } from 'shared/interfaces/IMedia';
import { IProfileMedia } from 'shared/interfaces/IProfile';
import { mediaService } from 'shared/services/mediaService';
import { profileService } from 'shared/services/profileService';
import ImageItem from '../Items/ImageItem';
const { getMediaList } = mediaService();
const { getMediaProfile } = profileService();
interface Props {
  updateItem?: (id: any) => void;
  isMultiple?: boolean;
  selected?: string[];
  hidePrimary?: boolean;
}
function ImageBin({ updateItem, selected, hidePrimary }: Props) {
  const [images, setimages] = useState<IProfileMedia[]>([]);
  const { profileId } = useParams() as { profileId: string };
  const { data: mediaData } = getMediaList({ file_type: 'image', media_bin: true });
  const { data: mediaProfileData } = getMediaProfile(profileId, {
    file_type: 'image',
  });

  const filteredMedia = useMemo(() => {
    const items = mediaData && mediaProfileData ? mediaData.data : [];

    return items.filter(
      (item) => !mediaProfileData?.data.some((profileItem) => profileItem.attributes.medium_id === item.id),
    );
  }, [mediaData, mediaProfileData]);

  useEffect(() => {
    if (mediaProfileData) {
      const imageData = mediaProfileData?.data;
      setimages([...imageData]);
    }
  }, [mediaProfileData]);

  const renderPhotos = () => {
    const img = images.map((image: IProfileMedia, idx: number) => {
      return {
        id: image.attributes.medium_id,
        src: image.attributes.attachment,
        height: image.attributes.medium_height,
        width: image.attributes.medium_width,
        idx: idx + 1,
        isPrimary: image.attributes.primary,
      };
    });

    const filImg = filteredMedia.map((image: IMedia, idx: number) => {
      return {
        id: image.id,
        src: image.attributes.attachment_url,
        height: (image.attributes.height || 0) as number,
        width: (image.attributes.width || 0) as number,
        idx: idx + 1,
        isPrimary: false,
      };
    });

    return img.concat(filImg);
  };

  const renderedImages = renderPhotos();

  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}>
      {renderedImages.map((photo: IModifiedMedia) => (
        <ImageItem
          key={photo.id}
          check
          checked={selected && selected.indexOf(photo.id) > -1}
          src={photo.src}
          idx={photo.idx}
          img={photo}
          checkReturn={(id) => updateItem && updateItem(id)}
          isPrimary={hidePrimary ? false : photo.isPrimary}
        />
      ))}
    </div>
  );
}

export default ImageBin;
